import Icon from '../components/Icon.vue'

Icon.register({
  'football-ball': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M481.5 60.3C476.7 42.1 462.4 27.8 444.2 22.9 420.3 16.5 383 8.9 339.4 8L496 164.8C495.2 121.3 487.8 84.2 481.5 60.3zM14.5 451.7C19.3 469.9 33.6 484.2 51.8 489.1 75.7 495.5 113 503.1 156.6 504L0 347.2C0.8 390.7 8.2 427.8 14.5 451.7zM4.2 283.4L220.4 500C352.9 480.6 469.2 381.3 491.9 228.6L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zM321.5 159.8C324.6 156.7 329.7 156.7 332.8 159.8L344.1 171.1C347.2 174.2 347.2 179.3 344.1 182.4L315.8 210.7 344.1 239C347.2 242.1 347.2 247.2 344.1 250.3L332.8 261.6C329.7 264.7 324.6 264.7 321.5 261.6L293.2 233.3 270.6 256 298.9 284.3C302 287.4 302 292.5 298.9 295.6L287.6 306.9C284.5 310 279.4 310 276.3 306.9L248 278.6 225.4 301.2 253.7 329.5C256.8 332.6 256.8 337.7 253.7 340.8L242.4 352.1C239.3 355.2 234.2 355.2 231.1 352.1L202.8 323.8 174.5 352.1C171.4 355.2 166.3 355.2 163.2 352.1L151.9 340.8C148.8 337.7 148.8 332.6 151.9 329.5L180.2 301.2 151.9 273C148.8 269.9 148.8 264.8 151.9 261.7L163.2 250.4C166.3 247.3 171.4 247.3 174.5 250.4L202.8 278.7 225.4 256.1 197.1 227.8C194 224.7 194 219.6 197.1 216.5L208.4 205.2C211.5 202.1 216.6 202.1 219.7 205.2L248 233.5 270.6 210.9 242.3 182.6C239.2 179.5 239.2 174.4 242.3 171.3L253.6 160C256.7 156.9 261.8 156.9 264.9 160L293.2 188.3 321.5 159.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/football-ball.js
// module id = LLnE
// module chunks = 144